import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { District } from './district.model';

export const DistrictActions = createActionGroup({
  source: 'District/API',
  events: {
    'Load Districts': props<{ districts: District[] }>(),
    'Add District': props<{ district: District }>(),
    'Upsert District': props<{ district: District }>(),
    'Add Districts': props<{ districts: District[] }>(),
    'Upsert Districts': props<{ districts: District[] }>(),
    'Update District': props<{ district: Update<District> }>(),
    'Update Districts': props<{ districts: Update<District>[] }>(),
    'Delete District': props<{ id: string }>(),
    'Delete Districts': props<{ ids: string[] }>(),
    'Clear Districts': emptyProps(),

    // Effect actions
    'Get All District By Region':props<{ regionUniqueId: string }>(),
    'Districts Loading State': props<{ loading: boolean }>(),
  }
});
